import { CustomObject } from '~/generated/graphql';

import { ClearbitResource, ObjectType } from '../Show/FieldMappingForm/types';

const getClearbitResourceType = (
  customObject: CustomObject,
): ClearbitResource => {
  if (customObject.identifierType === 'domain') {
    return 'company';
  }

  return 'person';
};

export const customObjectToFullObjectType = (
  customObject: CustomObject,
): ObjectType => {
  return {
    name: customObject.externalObjectType,
    label: customObject.externalObjectName,
    type: getClearbitResourceType(customObject),
  };
};
